import React from 'react';
import ReactDOM from 'react-dom';
import { TimelineContainer } from "./components";

export const initTimeline = (target) => {
  if (target) {
    const data = JSON.parse(target.dataset.data);
    ReactDOM.render(
      <TimelineContainer
        data={data}
      />,
      target
    );
  }
}
